module.exports = __webpack_public_path__ + "static/media/15UN-Habitat10.d8621a76.jpg";